import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section id="hero" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-black" data-id="element-199">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=1920&q=80)'
    }} aria-hidden="true" data-id="element-200" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" aria-hidden="true" data-id="element-201" />
      <div className="absolute inset-0 bg-gradient-to-r from-orange-900/20 to-transparent" aria-hidden="true" data-id="element-202" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-203">
        {/* Logo Mark */}
        <div className="flex justify-center mb-6" data-id="element-204"></div>

        {/* Powered By */}
        <p className="text-orange-500 font-semibold text-sm md:text-base uppercase tracking-[0.3em] mb-4" data-id="element-205">
          {t('hero.poweredBy')}
        </p>

        {/* Race Name */}
        <h1 className="font-display sm:text-7xl md:text-8xl lg:text-9xl tracking-wider text-white mb-2 text-[85px] pt-[1px] pb-[1px] ml-[115px] mr-[115px]" data-id="element-206">
          MOTOMANIAC
        </h1>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-wider text-gradient leading-none mb-8" data-id="element-207">
          HARD ENDURO RACE
        </h2>

        {/* Slogan */}
        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-4 max-w-2xl mx-auto" data-id="element-208">
          {t('hero.tagline')}
        </p>
        <p className="md:text-lg text-gray-500 mb-12 max-w-xl mx-auto text-center text-[16px] font-[400] px-6 md:px-0 ml-[90px] mr-[90px]" data-id="element-209">
          {t('hero.description')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-210">
          <button onClick={() => {
          const el = document.getElementById('contact');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="px-10 py-4 bg-orange-500 hover:bg-orange-600 text-black font-bold text-lg uppercase tracking-wider rounded transition-all hover:scale-105 cursor-pointer" data-id="element-211">
            {t('nav.register')}
          </button>
          <a href="#info" className="px-10 py-4 border-2 border-white/30 hover:border-orange-500 text-white font-bold text-lg uppercase tracking-wider rounded transition-all hover:scale-105" data-id="element-212">
            {t('hero.learnMore')}
          </a>
        </div>

        {/* Date Badge */}
        <div className="mt-12 inline-flex gap-3 px-6 py-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-full pl-[150px] pr-[150px] items-center justify-start" data-id="element-213">
          <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" aria-hidden="true" data-id="element-214" />
          <span className="text-gray-300 font-semibold uppercase tracking-wider text-[12px]" data-id="element-215">
            <a target="_blank" href="https://maps.app.goo.gl/PH2bEhniw2BQLDwa7" data-id="element-216">
              {' '}
              Pāvuli, Raunas novads, Raunas pagasts, Smiltenes novads,
              LV-4131{' '}
            </a>
          </span>
        </div>
      </div>
    </section>;
}